/* eslint-disable no-nested-ternary */
/* global G */
import { findPosition } from 'platform/adapter/cart/helper'

/**
 * Removes a position from the current cart matched by key or name, or clears all positions
 * when `all` is true. Dispatches `G.CART, G.SET` afterward.
 *
 * @param {Gaia.Web.Application} app  the Platform Web Application
 * @returns {AttachmentEventListener}  an AttachmentEventListener
 */
const fn = app => async ({ detail = {} }) => {
  const { key, name, all = false } = detail[G.DATA]

  const adapter = app[G.ADAPTER][G.CART]
  const activeCart = adapter[G.DATA]
  const eventBus = app[G.ADAPTER][G.EVENTS]

  const newCart = {
    ...activeCart,
    value: {
      ...activeCart.value,
      positions: all ? [] : activeCart.value.positions.filter(position => !findPosition([position], { key, name })),
    },
    refs: {
      ...activeCart.refs,
      article: all
        ? []
        : key
          ? activeCart.refs.article.filter(ref => ref !== key)
          : activeCart.refs.article,
    },
  }

  eventBus.dispatch(eventBus.type(G.CART, G.SET), { [G.DATA]: newCart })
}

export default fn
